import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'premium';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#f5efe1]';
  const variants = {
    // Gold CTA on dark-green text
    primary: 'bg-[#c8971b] hover:bg-[#b0850f] text-[#14301f] focus:ring-[#c8971b] shadow-[0_4px_14px_0_rgba(200,151,27,0.35)] hover:shadow-[0_6px_20px_rgba(200,151,27,0.5)] hover:-translate-y-0.5',
    // Green solid
    secondary: 'bg-[#1e4230] hover:bg-[#173325] text-[#f5efe1] focus:ring-[#2f6b47] shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    // Green outline
    outline: 'border-2 border-[#1e4230] hover:bg-[#1e4230] text-[#1e4230] hover:text-[#f5efe1] focus:ring-[#2f6b47] bg-transparent',
    // Premium gold gradient
    premium: 'bg-gradient-to-r from-[#e7c766] to-[#c8971b] hover:from-[#c8971b] hover:to-[#b0850f] text-[#14301f] focus:ring-[#c8971b] shadow-[0_4px_14px_0_rgba(200,151,27,0.4)] hover:shadow-[0_6px_20px_rgba(200,151,27,0.55)] hover:-translate-y-0.5 border border-[#b0850f]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-323">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-324" />}
    </motion.button>;
}